import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AddressFields from 'bundles/apex/deals/form/fields/address_fields';
import Area from 'bundles/apex/deals/form/fields/area';
import Card from './card';
import Cards from 'bundles/apex/card/container';
import CancelButton from 'bundles/apex/deals/form/cancel_button';
import Currency from 'bundles/apex/deals/form/fields/currency';
import CustomFields from 'bundles/apex/deals/form/fields/custom_fields';
import Errors from 'bundles/apex/deals/form/errors';
import GrossCommission from 'bundles/apex/deals/form/fields/gross_commission';
import InternalBrokers from 'bundles/apex/deals/form/fields/internal_brokers';
import LeaseRate from 'bundles/apex/deals/form/fields/lease_rate';
import LeaseStructure from 'bundles/apex/deals/form/fields/lease_structure';
import LeaseTerm from 'bundles/apex/deals/form/fields/lease_term';
import LeaseTerms from 'bundles/apex/deals/form/fields/lease_terms';
import LeaseType from 'bundles/apex/deals/form/fields/lease_type';
import Numeric from 'bundles/apex/deals/form/fields/numeric';
import OutsideBrokers from 'bundles/apex/deals/form/fields/outside_brokers';
import Percentage from 'bundles/apex/deals/form/fields/percentage';
import PropertyType from 'bundles/apex/deals/form/fields/property_type';
import AgreementType from 'bundles/apex/deals/form/fields/agreement_type';
import SaveButton from 'bundles/apex/deals/form/save_button';
import SpaceSize from 'bundles/apex/deals/form/fields/space_size';
import Text from 'bundles/apex/deals/form/fields/text';
import TextArea from 'bundles/apex/deals/form/fields/textarea';
import TransactionSideCard from './transaction_side_card';
import TransactionValue from 'bundles/apex/deals/form/fields/transaction_value';
import { BUY_SIDE, SELL_SIDE } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';
import { getPropertySectionLabel } from 'bundles/apex/deals/helpers/labels';
import { canHaveLeaseTerms } from 'bundles/apex/deals/lease_terms/helpers';

import './styles.scss';

export function DealForm({ deal, fields, onCancel, onSave }) {
  return (
    <Cards className="deal-form deal-form-overview">
      <Card className="deal-card" fullWidth>
        <div className="controls">
          <CancelButton onCancel={onCancel} />
          <SaveButton onSave={onSave}/>
        </div>
      </Card>

      <Errors/>

      {!deal.hasTransactionSides && <React.Fragment>
        <Card label="Internal Brokers">
          <InternalBrokers/>
        </Card>
        <Card label="Outside Brokers">
          <OutsideBrokers/>
        </Card>
      </React.Fragment>}

      <Card label={getPropertySectionLabel(deal)}>
        <PropertyType/>
        <TextArea name="requirements" />
        <Text name="propertyName" />
        <AddressFields/>
        <Numeric name="buildingSize" />
        <Area name="lotSize" />
        <SpaceSize/>
        <Numeric name="numberOfUnits" />
        <Percentage name="occupancyPercent" />
        <Numeric name="yearBuilt" />
        <CustomFields category="property" />
      </Card>

      <Card label="Transaction">
        <Text label="Deal ID" name="identifier" />
        <Text label="Deal Title" name="name" />
        <AgreementType />
        <LeaseType/>
        <LeaseRate/>
        <LeaseTerm/>
        <TransactionValue/>
        <GrossCommission/>
        <LeaseStructure/>
        <Numeric name="capRate" />
        <Currency name="netOperatingIncome" />
        <Percentage name="closeProbability" />
        <Text name="deadReason" />
        <CustomFields category="financials" />
      </Card>

      {!!deal.hasTransactionSides && <React.Fragment>
        <TransactionSideCard transactionSide={SELL_SIDE} />
        <TransactionSideCard transactionSide={BUY_SIDE} />
      </React.Fragment>}

      {Object.values(fields).filter(field => field.custom && !field.category && !field.hidden).length > 0 &&
        <Card label="Custom Fields">
          <CustomFields category={null} />
        </Card>
      }

      {canHaveLeaseTerms(fields) &&
        <Card className="deal-lease-terms-card" fullWidth label="Rent Schedule">
          <LeaseTerms/>
        </Card>
      }
    </Cards>
  );
}

DealForm.propTypes = {
  deal: PropTypes.shape({
    dealType: PropTypes.string.isRequired,
    hasTransactionSides: PropTypes.bool,
    transactionSideDetails: PropTypes.array,
  }).isRequired,
  fields: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  fields: state.fields,
});

export default connect(mapStateToProps)(DealForm);
